module.exports = __webpack_public_path__ + "static/media/exercise.d3bda992.jpg";